import React from 'react';
import { Col, Row, Container } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
export function ComparisonSkeleton() {
    const { isInfiniteDesktopView } = useWindowSize();
    return (React.createElement(Container, null,
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(Skeleton, { skeletonProps: {
                        height: isInfiniteDesktopView ? 56 : 32,
                    }, wrapperProps: {
                        width: 300,
                        mtL: 48,
                        mtM: 32,
                        mbM: 16,
                        mbS: 16,
                    } }),
                React.createElement(Skeleton, { skeletonProps: {
                        height: 24,
                    }, wrapperProps: {
                        width: 300,
                        mbL: 56,
                        mbM: 16,
                        mbS: 16,
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(Skeleton, { skeletonProps: {
                        height: 300,
                    }, wrapperProps: {
                        mbL: 56,
                        mbM: 16,
                        mbS: 16,
                    } }),
                React.createElement(Skeleton, { skeletonProps: {
                        height: 800,
                    }, wrapperProps: {
                        mbL: 56,
                        mbM: 16,
                        mbS: 16,
                    } })))));
}
